import { render, staticRenderFns } from "./imgSelect.vue?vue&type=template&id=279cab54&"
import script from "./imgSelect.vue?vue&type=script&lang=js&"
export * from "./imgSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pc/components/asq/imgSelect.vue"
export default component.exports